import { toast } from "react-toastify";
import { createSlice } from '@reduxjs/toolkit';
import ReconciliationService from "../../services/ReconciliationService";    

interface APIResponse {
    data: {
        status: number,
        message: string,
        data?: any
    }
}

const Reconciliation = createSlice({
    name: 'reconciliation',
    initialState: {
        reconciliationList: {},
    },
    reducers: {
        reconciliationList: (state, action) => {
            state.reconciliationList = action.payload
        }
    }
})

export default Reconciliation.reducer;

const { reconciliationList } = Reconciliation.actions


/**
 * Function to make API call to fetch Reconciliation listing
 * @param params 
 * @returns 
 */
export const getReconciliationList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {        
        ReconciliationService.getReconciliationListing(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                        dispatch(reconciliationList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const PaymentApproveReject = (params: object) => {
    return new Promise((resolve, reject) => {
        ReconciliationService.PaymentApproveReject(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const AssignPayment = (params: object) => {
    return new Promise((resolve, reject) => {
        ReconciliationService.AssignPayment(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        if (response.data.message) toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const bulkPaymentAssignee = (params: object) => {
    return new Promise((resolve, reject) => {
        ReconciliationService.bulkPaymentAssignee(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        if (response.data.message) toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}






